export default function getResource(label) {
    const resources = {
        backButton: 'Back'
    };

    return resources[label];
}
